import type { Nullable } from "../../../typescript"
import type { EntityList } from "../state/EntityList.type"
import { POSTGRES_MAX_INT } from "../util/math/number"
import { ELEVATION_SIZE } from "./EntityElevation/elevation_consts"
import isEntityHasFloorElevation from "./EntityElevation/isEntityHasFloorElevation"
import { EntityLayerId } from "./EntityLayerId/EntityLayerId.enum"
import { isEntityBuilding, isEntityFactory, isEntityForest, isEntityHQ, isEntityMountain, isEntityRoad } from "./entityTypeMetaList.generated"
import type { Entity } from "./index"

export default function getEntityRenderHeight (stack : EntityList, ent1: Nullable<Entity> = null): number {
  const ent1LayerId = ent1?.layer_id || POSTGRES_MAX_INT
  if (ent1) {
    if (isEntityHasFloorElevation(ent1)) {
      return ent1.floor_e * ELEVATION_SIZE
    }
  }
  for (const ent2 of stack) {
    if (ent2.layer_id < ent1LayerId) {
      if (isEntityHasFloorElevation(ent2)) {
        return ent2.floor_e * ELEVATION_SIZE
      }
      // everything below is probably deprecated
      if (isEntityMountain(ent2)) {
        return 12
      }
      if (isEntityForest(ent2)) {
        return 2
      }
      if (isEntityHQ(ent2)) {
        return 17
      }
      if (isEntityBuilding(ent2)) {
        return 10
      }
      if (isEntityFactory(ent2)) {
        return 10
      }
      if (isEntityRoad(ent2)) {
        return 2
      }
    }
  }
  if ((ent1?.layer_id as number) > EntityLayerId.TerrainL1) {
    return 1
  }
  return 0
}